
export default {
  data() {
    return {};
  },
  methods: {},
  components: {}
};
